// extracted by mini-css-extract-plugin
export var activeFilterButton = "_p5-c";
export var backButton = "_p5-4";
export var backIcon = "_p5-5";
export var chevronShortcut = "_p5-6";
export var container = "_p5-1";
export var editor = "_p5-8";
export var editorWrapper = "_p5-7";
export var prefix = "_p5-2";
export var searchIcon = "_p5-3";
export var suffix = "_p5-9";
export var suffixContent = "_p5-a";
export var suffixText = "_p5-b";
export var wrapper = "_p5-0";